
// Types of data we want to fetch from the raw stats
export const TYPES = {
  REVENUES: {
    id: "REVENUES",
    label: "Revenue",
    visibleFor: (jurisdictionId) => jurisdictionId !== null, // Can't sum different currencies
    dataFetcher: (data) => data.revenue_before_tax.total,
  },
  REVENUES_SUBS: {
    id: "REVENUES_SUBS",
    label: "Subscription Revenue",
    visibleFor: (jurisdictionId) => jurisdictionId !== null, // Can't sum different currencies
    dataFetcher: (data) => data.revenue_before_tax.subs + data.revenue_before_tax.subs_new,
  },
  REVENUES_OT: {
    id: "REVENUES_OT",
    label: "One-Time Order Revenue",
    visibleFor: (jurisdictionId) => jurisdictionId !== null, // Can't sum different currencies
    dataFetcher: (data) => data.revenue_before_tax.others,
  },
  ORDERS: {
    id: "ORDERS",
    label: "Orders",
    tooltip: "Sum of all orders, either subscriptions or one-time",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.total,
  },
  ORDERS_ONETIME: {
    id: "ORDERS_ONETIME",
    label: "One-time Orders",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.others,
  },
  SUBS: {
    id: "SUBS",
    label: "Subscription orders",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.subs,
  },
  SUBS_NEW: {
    id: "SUBS_NEW",
    label: "New Subscriptions",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.subs_new,
  },
  SUBS_CANCELLED: {
    id: "SUBS_CANCELLED",
    label: "Cancellations",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.subs_cancelled,
  },
  SUBS_PAUSED: {
    id: "SUBS_PAUSED",
    label: "Paused Subscriptions",
    visibleFor: () => true,
    dataFetcher: (data) => data.orders.subs_paused,
  },
  CUSTOMERS_ACTIVE: {
    id: "CUSTOMERS_ACTIVE",
    label: "Active customers",
    visibleFor: () => true,
    dataFetcher: (data) => data.active_customers,
  },
  LITERS_SOLD: {
    id: "LITERS_SOLD",
    label: "Liters sold",
    visibleFor: () => true,
    dataFetcher: (data) => data.liters_sold,
  }
}
